import { axiosInstance } from '../../helpers'
import {
    GetSubContractSummaryParams,
    SubContractSummaryResponseRaw,
    mapSubContractSummaryToViewModel,
    SubContractSummaryViewModel,
} from '../../store/workorder/workorder/subContractTypes'
import FileDownload from 'js-file-download'

export type FetchSubContractSummaryParams = GetSubContractSummaryParams & {
    all_jobsites?: boolean
}

export const fetchSubContractSummary = async (
    params: FetchSubContractSummaryParams = {},
): Promise<SubContractSummaryViewModel> => {
    const res = await axiosInstance.get<SubContractSummaryResponseRaw>(
        'workorder/workorder-sub-contract/summary/',
        { params },
    )
    return mapSubContractSummaryToViewModel(res.data)
}

const filenameFromContentDisposition = (
    header: string | undefined,
    fallback: string,
): string => {
    if (!header) {
        return fallback
    }
    const match = /filename="([^"]+)"/.exec(header)
    return match?.[1] ?? fallback
}

export const downloadSubContractSummaryExport = async (
    params: FetchSubContractSummaryParams = {},
): Promise<void> => {
    const res = await axiosInstance.get(
        'workorder/workorder-sub-contract/summary-export/',
        { params, responseType: 'blob' },
    )
    const fallback = `sub-payouts-${new Date().toISOString().slice(0, 10)}.xlsx`
    const filename = filenameFromContentDisposition(
        res.headers['content-disposition'] as string | undefined,
        fallback,
    )
    FileDownload(
        new Blob([res.data], {
            type:
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        }),
        filename,
    )
}
